var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 14.75H14.75V25.25H11.25V14.75H0.75V11.25H11.25V0.75H14.75V11.25H25.25V14.75Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocument);
export default __webpack_public_path__ + "static/media/AddDocument.93f13fbac13ec9ecf28b31b95ce92bf3.svg";
export { ForwardRef as ReactComponent };